import React from 'react';
import Form from 'react-bootstrap/Form';

class AutomationCreation extends React.Component {

  constructor(props) {
    super(props);
    this.state = { auto_call: false, meeting: false, pipeline: false, ...props.value };
  }

  onChange = (field, val) => {
    const state = { ...this.state };
    state[field] = val;
    this.props.onChange(field, val);
    this.setState({ ...state });
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="col">
          <div className="form-group display-flixr">
            <Form.Check>
              <Form.Check.Input type="checkbox" checked={this.state.auto_call}
                onChange={event => this.onChange('auto_call', event.target.checked)} />
              <Form.Check.Label> Create Call </Form.Check.Label>
            </Form.Check>
            <Form.Check className="checkmar">
              <Form.Check.Input type="checkbox" checked={this.state.meeting}
                onChange={event => this.onChange('meeting', event.target.checked)} />
              <Form.Check.Label> Create Meeting </Form.Check.Label>
            </Form.Check>
            {false &&
              <Form.Check>
                <Form.Check.Input type="checkbox" checked={this.state.pipeline}
                  onChange={event => this.onChange('pipeline', event.target.checked)} />
                <Form.Check.Label> Create Sales Order </Form.Check.Label>
              </Form.Check>
            }
          </div>
        </div>
      </div>
    );
  }
}
export default AutomationCreation;
